<div class="request mb-5">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboard">
                Inicio
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <h2 class="txt txt--title">Actualizar licencia mina</h2>
        <small>A través del siguiente formulario podrás actualizar las competencias de un conductor con licencia en zona
          mina.</small>
      </div>

      <app-form-select-person-mine [controlForm]="driverFormGroup" class="global-full-width"></app-form-select-person-mine>

      <app-license-mine-update-detail
      class="global-full-width"
      *ngIf="driverFormGroup.valid"
       [selectedPersonEmail]="driverFormGroup.value.email"
       [selectedPersonMdmid]="driverFormGroup.value.mdmid"
       [mineDocumentTable]="mineDocumentsFormArray"
       ></app-license-mine-update-detail>


    </div>
  </div>
</div>
